import axios from "axios";
import { notification } from "antd";

/* eslint-disable */

const host = import.meta.env.VITE_LOGISTICS_HOST || "";

const httpStatusError = {
  HTTP_UNAUTHENTICATED: 401,
  HTTP_PERMISSION_DENINED: 403,
};

const httpStatusErrorArr = [httpStatusError.HTTP_UNAUTHENTICATED, httpStatusError.HTTP_PERMISSION_DENINED];

export const getApi = async (domain, accessToken, param) => {
  try {
    for (const key in param) {
      if (param.hasOwnProperty(key) && param[key] === null) {
        delete param[key];
      }
    }
    const { data } = await axios({
      url: `/${domain}`,
      baseURL: host,
      method: `GET`,
      params: param,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": `application/json`,
      },
    });
    return data;
  } catch (error) {
    const status = error?.response?.status || 500;
    const message = error?.response?.data?.message || error.message || "An unexpected error occurred. Please try again.";
    handlerResponseErr(status, message);
  }
};

export const postApi = async (domain, accessToken, body) => {
  try {
    const { data } = await axios({
      url: `/${domain}`,
      baseURL: host,
      method: `POST`,
      data: body,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        ContentType: `application/json`,
      },
    });
    return data;
  } catch (error) {
    const errorCode = [422, 403, 400];
    if (errorCode.includes(error.response.status)) {
      return error;
    }
    handlerResponseErr(error.response.status, error.message);
  }
};

export const postAuthApi = async (domain, body) => {
  try {
    const { data } = await axios({
      url: `/${domain}`,
      baseURL: host,
      method: `POST`,
      data: body,
      headers: {
        ContentType: `application/json`,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const postApiRoute = async (domain, accessToken, body, req, res) => {
  try {
    const response = await axios({
      url: `/${domain}`,
      baseURL: host,
      method: `POST`,
      data: body,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        ContentType: `application/json`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const postApiFromData = async (domain, accessToken, body) => {
  try {
    const { data } = await axios({
      url: `/${domain}`,
      baseURL: host,
      method: `POST`,
      data: body,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        // "Content-Type": "multipart/form-data",
      },
    });

    return data;
  } catch (error) {
    throw error;
  }
};

export const putApiRoute = async (domain, accessToken, body) => {
  try {
    const response = await axios({
      url: `/${domain}`,
      baseURL: host,
      method: `PUT`,
      data: body,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        ContentType: `application/json`,
      },
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export const putApi = async (domain, accessToken, body) => {
  try {
    const { data } = await axios({
      url: `/${domain}`,
      baseURL: host,
      method: `PUT`,
      data: body,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        ContentType: `application/json`,
      },
    });

    return data;
  } catch (error) {
    handlerResponseErr(error.response.status, error.response.message);
  }
};

export const updateApi = async (domain, accessToken, body) => {
  try {
    const { data } = await axios({
      url: `/${domain}`,
      baseURL: host,
      method: `PUT`,
      data: body,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        ContentType: `application/json`,
      },
    });
    return data;
  } catch (err) {
    console.error("[httpsClient] updateApi: ", err);
    throw err;
  }
};

export const putApiWithHandlerError = async (domain, accessToken, body) => {
  try {
    const { data } = await axios({
      url: `/${domain}`,
      baseURL: host,
      method: `PUT`,
      data: body,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        ContentType: `application/json`,
      },
    });

    return data;
  } catch (error) {
    return handlerResponseErr(error.response.status, error.response.data.message);
  }
};

export const putApiFromData = async (domain, accessToken, body) => {
  try {
    const { data } = await axios({
      url: `/${domain}`,
      baseURL: host,
      method: `PUT`,
      data: body,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        // "Content-Type": "multipart/form-data",
      },
    });

    return data;
  } catch (error) {
    if (error.response) {
      handlerResponseErr(error.response.status, error.message);
    } else {
      console.error("Network or CORS error", error);
    }
  }
};

export const deleteApi = async (domain, accessToken, body) => {
  try {
    const { data } = await axios({
      url: `/${domain}`,
      baseURL: host,
      method: `DELETE`,
      data: body,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        ContentType: `application/json`,
      },
    });

    return data;
  } catch (error) {
    const status = error?.response?.status ?? 500;
    const msg = error?.response?.data?.message ?? error.message;
    handlerResponseErr(status, msg);
    throw error;
  }
};

export const deleteApiQueryString = async (domain, accessToken) => {
  try {
    const { data } = await axios({
      url: `/${domain}`,
      baseURL: host,
      method: `DELETE`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        ContentType: `application/json`,
      },
    });

    return data;
  } catch (error) {
    handlerResponseErr(error.response.status, error.message);
  }
};

export const exportExcel = async (domain, accessToken, param) => {
  for (const key in param) {
    if (param.hasOwnProperty(key) && param[key] === null) {
      delete param[key];
    }
  }
  try {
    const response = await axios({
      url: `/${domain}`,
      baseURL: host,
      method: "GET",
      params: param,
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        ContentType: `application/json`,
        "Access-Control-Allow-Origin": "*",
      },
    });
    return response;
  } catch (error) {
    console.error("Error exporting Excel:", error);
    throw error;
  }
};

export const exportExcelZip = async (domain, accessToken, param) => {
  for (const key in param) {
    if (param.hasOwnProperty(key) && param[key] === null) {
      delete param[key];
    }
  }
  try {
    const response = await axios({
      url: `/${domain}`,
      baseURL: host,
      method: "GET",
      params: param,
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        ContentType: `application/zip`,
        "Access-Control-Allow-Origin": "*",
      },
    });
    return response;
  } catch (error) {
    console.error("Error exporting Excel:", error);
    throw error;
  }
};

export const exportExcelPost = async (domain, accessToken, param) => {
  try {
    const response = await axios({
      url: `/${domain}`,
      baseURL: host,
      method: "Post",
      data: param,
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        ContentType: `application/json`,
        "Access-Control-Allow-Origin": "*",
      },
    });
    return response;
  } catch (error) {
    console.error("Error exporting Excel:", error);
    throw error;
  }
};

export const handlerResponseErr = (status, message) => {
  console.error("Handler Error:", status, message);

  if (status === 401) {
    // ถ้า Token หมดอายุหรือไม่ถูกต้อง
    notification.error({
      message: "Session Expired",
      description: "session expired",
    });
  } else {
    // กรณี Error อื่น ๆ
    notification.error({
      message: `เกิดข้อผิดพลาด (Error ${status})`,
      description: message || "ไม่สามารถทำรายการได้ในขณะนี้",
      duration: 3,
    });
  }
};
